import { OfferStatus } from '../offer/offer.enums';
import { Visibility } from '../visibility/visibility.types';
import { EmailProviderData } from './email-providers.types';

export enum SharedEmailProviders {
  Google = 'google',
  Microsoft = 'outlook',
  Mailbox = 'mailbox',
}

type OfferAutomatedAction = {
  id: number;
  offer: {
    id: number;
    status: `${OfferStatus}`;
    title: string;
  };
  stage: {
    category: string;
    id: number;
    name: string;
  };
};

type DisqualifyReasonAutomatedAction = {
  id: number;
  disqualifyReason: { id: number; name: string };
};

export type SharedEmailProviderConnectionStatus =
  | 'initial'
  | 'connected'
  | 'error'
  | 'disconnected';

export interface SharedEmailProvider extends EmailProviderData {
  provider: `${SharedEmailProviders}`;
  archivedAt: string | null;
  name: string | null;
  signature: string;
  visibility: Visibility;
  connectUrl?: string;
  connectionStatus: SharedEmailProviderConnectionStatus;
  automatedActions: Array<OfferAutomatedAction & DisqualifyReasonAutomatedAction>;
}
